import React, { useRef, useEffect, useState } from "react";

const LS_NAME = "audioMessageRate";

export default function Audio({ url }) {
  const audioRef = useRef(null);
  const [audioRate, setAudioRate] = useState(
    parseFloat(localStorage.getItem(LS_NAME) || "1")
  );
  const [showButtonRate, setShowButtonRate] = useState(false);

  useEffect(() => {
    audioRef.current.playbackRate = audioRate;
    localStorage.setItem(LS_NAME, audioRate);
  }, [audioRate]);

  useEffect(() => {
    audioRef.current.onplaying = () => {
      setShowButtonRate(true);
    };
    audioRef.current.onpause = () => {
      setShowButtonRate(false);
    };
    audioRef.current.onended = () => {
      setShowButtonRate(false);
    };
  }, []);

  const toggleRate = () => {
    let newRate = null;

    switch (audioRate) {
      case 0.5:
        newRate = 1;
        break;
      case 1:
        newRate = 1.5;
        break;
      case 1.5:
        newRate = 2;
        break;
      case 2:
        newRate = 0.5;
        break;
      default:
        newRate = 1;
        break;
    }

    setAudioRate(newRate);
  };

  return (
    <div className="flex items-center gap-1">
      <audio ref={audioRef} controls className="max-w-[250px]">
        <source src={url} type="audio/ogg"></source>
      </audio>
      {showButtonRate && (
        <button
          onClick={toggleRate}
          className="px-2 py-1 text-xs font-medium text-primary-600 dark:text-primary-400 bg-dark-100 dark:bg-dark-700 hover:bg-dark-200 dark:hover:bg-dark-600 rounded transition-colors -mt-11"
        >
          {audioRate}x
        </button>
      )}
    </div>
  );
}
